import { useState } from "react";

// sizes: array of strings
export const SizeSelector = ({ sizes = [], testid = "size-selector" }) => {
  const [active, setActive] = useState(0);
  return (
    <div data-testid={testid}>
      <div className="flex items-baseline justify-between">
        <span className="eyebrow">Specifications</span>
        <span className="text-xs text-muted-foreground">
          {sizes.length} size{sizes.length > 1 ? "s" : ""} to choose from
        </span>
      </div>
      <div className="mt-5 flex flex-col gap-3">
        {sizes.map((s, i) => (
          <button
            key={s}
            type="button"
            onClick={() => setActive(i)}
            data-testid={`${testid}-${i}`}
            className={`flex items-center justify-between border px-5 py-4 text-left text-sm tracking-editorial transition-colors ${
              active === i
                ? "border-foreground bg-foreground text-background"
                : "border-border/60 hover:border-foreground"
            }`}
          >
            <span>{s}</span>
            <span className="text-xs uppercase tracking-[0.16em] opacity-70">
              {active === i ? "Selected" : "Select"}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};
